import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from "moment";

function Table(props) {
  const { data } = props;
  const [totals, setTotals] = useState({
    uniq_player: 0,
    total_player: 0,
    bonus_amount: 0
  });

  const columns = [
    {
      dataField: "day",
      text: "Day Of Month",
      sort: true,
      footer: () => <strong>Total</strong>
    },
    {
      dataField: "uniq_player",
      text: "Unique Players",
      sort: true,
      formatter: (cell, row) => <>{Number(row.uniq_player).toLocaleString('en-GB')}</>,
      footer: () => <strong>{totals.uniq_player.toLocaleString('en-GB')}</strong>
    },
    {
      dataField: "total_player",
      text: "Total Players",
      sort: true,
      formatter: (cell, row) => <>{Number(row.total_player).toLocaleString('en-GB')}</>,
      footer: () => <strong>{totals.total_player.toLocaleString('en-GB')}</strong>
    },
    {
      dataField: "bonus_amount",
      text: "Total Bonus",
      sort: true,
      formatter: (cell, row) => <>{Number(row.bonus_amount).toLocaleString('en-GB')}</>,
      footer: () => <strong>{totals.bonus_amount.toLocaleString('en-GB')}</strong>
    }
  ];

  useEffect(() => {
    calculateTotals();
  }, [data]);

  const calculateTotals = () => {
    let totalUniqPlayers = 0;
    let totalPlayers = 0;
    let totalBonus = 0;

    data.forEach(item => {
      totalUniqPlayers += parseInt(item.uniq_player);
      totalPlayers += parseInt(item.total_player);
      totalBonus += parseFloat(item.bonus_amount);
    });

    setTotals({
      uniq_player: totalUniqPlayers,
      total_player: totalPlayers,
      bonus_amount: totalBonus
    });
  };

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  const { SearchBar } = Search;
  const pageOptions = {
    sizePerPage: data.length,
    totalSize: data.length,
    custom: true,
  };

  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Multibet Bonus Report"}</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={columns}
            data={data}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col sm="6">
                        <Row>
                          <Col sm="6">
                            <div className="search-box me-2 mb-2 d-inline-block">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                          <Col sm="6">
                            <div>
                              <ReactHTMLTableToExcel
                                id="test-table-xls-button"
                                className="download-table-xls-button w-md btn btn-primary"
                                table="table-to-xls"
                                filename={`Multi-Bet-Bonus-Report-${moment(new Date()).format("DD/MM/YYYY")}`}
                                sheet="tablexls"
                                buttonText="Download"
                                type="button"
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={6}></Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable id="table-to-xls"
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </>
  );
}

export default Table;
